import {
  HeaderContainer,
  ButtonMenuToggle,
  DropDown,
  HeaderStyled,
  NavbarStyled,
  NavbarModalStyled,
  NavbarLinkStyled,
  NavbarButtonStyled,
  NavbarButtonLoginStyled,
  Modal,
} from "./styles";

import { useNavigate } from "react-router-dom";
import { useState } from "react";
import logo from "../../assets/logoWhite.svg";
import useAuth from "../../hooks/useAuth";
import HeaderAuth from "../HeaderAuth";

export default function Header() {
  const { user } = useAuth();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  function handleToggleModal() {
    setIsModalOpen(!isModalOpen);
  }

  function handleModalClick(e: any) {
    if (e.target.id === "modal") {
      setIsModalOpen(false);
    }
  }

  function handleMouseEnter() {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    setIsDropdownOpen(true);
  }

  function handleMouseLeave() {
    const id: any = setTimeout(() => {
      setIsDropdownOpen(false);
    }, 1000);
    setTimeoutId(id);
  }

  const navigate = useNavigate();

  const handleHome = () => {
    navigate("/");
    if (isModalOpen) {
      setIsModalOpen(!isModalOpen);
    }
  };

  const handleSignin = () => {
    navigate("/signin");
    if (isModalOpen) {
      setIsModalOpen(!isModalOpen);
    }
  };

  return (
    <HeaderContainer>
      <div>
        {user?.name ? (
          <div className="auth-header">
            <HeaderAuth />
          </div>
        ) : null}

        <div>
          <HeaderStyled>
            <img src={logo} alt="" />
            <NavbarStyled>
              <ul>
                <li>
                  <NavbarButtonStyled onClick={handleHome}>
                    INÍCIO
                  </NavbarButtonStyled>
                </li>
                <li>
                  <NavbarButtonStyled
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    SERVIÇOS
                  </NavbarButtonStyled>
                  {isDropdownOpen && (
                    <DropDown
                      className="dropdown"
                      onMouseEnter={handleMouseEnter}
                      onMouseLeave={handleMouseLeave}
                    >
                      <li>
                        <button>Desenvolvimento de Software</button>
                      </li>
                      <li>
                        <button>Integração de APIs</button>
                      </li>
                      <li>
                        <button>Manutenção e Suporte</button>
                      </li>
                      <li>
                        <button>Consultoria em Tecnologia</button>
                      </li>
                      <li>
                        <button>Testes e Qualidade de Software</button>
                      </li>
                      <li>
                        <button>Serviços de Emergência</button>
                      </li>
                    </DropDown>
                  )}
                </li>
                <li>
                  <NavbarLinkStyled href="#contact">CONTATOS</NavbarLinkStyled>
                </li>
                {user?.name ? null : (
                  <li>
                    <NavbarButtonLoginStyled onClick={handleSignin}>
                      LOGIN
                    </NavbarButtonLoginStyled>
                  </li>
                )}
              </ul>
            </NavbarStyled>

            <ButtonMenuToggle onClick={handleToggleModal}>
              <span className="menu-icon"></span>
            </ButtonMenuToggle>

            {isModalOpen && (
              <Modal onClick={handleModalClick}>
                <div onClick={(e) => e.stopPropagation()}>
                  <div className="header-mobile">
                    <button
                      className="close-button"
                      onClick={handleToggleModal}
                    >
                      X
                    </button>
                  </div>
                  <NavbarModalStyled>
                    <ul>
                      <li>
                        <button onClick={handleHome}>INÍCIO</button>
                      </li>
                      <li>
                        <button onClick={handleSignin}>SERVIÇOS</button>
                      </li>
                      <li>
                        <a href="#contact">CONTATOS</a>
                      </li>
                      <li className="login-mobile">
                        <button onClick={handleSignin}>LOGIN</button>
                      </li>
                    </ul>
                  </NavbarModalStyled>
                </div>
              </Modal>
            )}
          </HeaderStyled>
        </div>
      </div>
    </HeaderContainer>
  );
}
